<app-tabs [defaultTab]="defaultTab()" (onChangeTab)="onTabChange($event)">
  <app-draft-creation-tab />
  <app-draft-editing-tab />
  <app-draft-deletion-tab />
</app-tabs>
